// src/components/CopyableText.js
import React from 'react';
import styled from 'styled-components';
import { colors, fonts, fontSizes, duration, ease, space } from '../styles/tokens';
import { useCopyToClipboard } from '../hooks/useCopyToClipboard';

const Wrap = styled.button`
  position: relative;
  display: block;
  width: 100%;
  text-align: left;
  font-family: ${fonts.mono};
  font-size: ${fontSizes.base};
  color: ${colors.text};
  padding: ${space[2]} 0;
  cursor: pointer;
  transition: color ${duration.fast} ${ease.soft};
  &:hover { color: ${colors.accent}; }
`;

const Toast = styled.span`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  font-size: ${fontSizes.xs};
  color: ${colors.accent};
  opacity: ${(p) => (p.$shown ? 1 : 0)};
  transition: opacity ${duration.base} ${ease.soft};
  pointer-events: none;
`;

export function CopyableText({ value, label }) {
  const { copy, copied } = useCopyToClipboard();
  return (
    <Wrap onClick={() => copy(value)} aria-label={`Copy ${label || value}`}>
      {value}
      <Toast $shown={copied} aria-live="polite">✓ copied</Toast>
    </Wrap>
  );
}
